import * as React from "react";

import {AccountRole, MultiBalanceDto} from "../../http/protocol";
import {NavLink} from "react-router-dom";
import {getContainer} from "../../ioc/IOCSetup";

interface Props {
    userId? : number;
    username?: string;
    balances?: MultiBalanceDto[]
}
export class AccountBalances extends React.Component<Props,{  }>{
    constructor(props : Props) {
        super(props);
        this.state = { };
    }
    componentDidMount(): void {

    }

    getAccounts(targetAccounts:MultiBalanceDto[]) {

        if(!targetAccounts  || targetAccounts.length === 0) {
            return <div className={"col-12"}><span>No accounts found for user</span></div>
        }

        return targetAccounts.map( (account, index) => {

            if(account.amount == undefined) {
                return <span key={account.accountId || index}>N/A</span>
            }
            
            const iconUrl = this.getCurrencyIconUrl(account.currencyCode, account.role);

            const content = (
                <div className={"row"}>
                    <div className="col-3 d-flex align-items-center">
                        {iconUrl && (
                            <img
                                src={iconUrl}
                                alt={account.currencyCode}
                                style={{width : "30px", height : "30px", borderRadius : "50%", marginRight : "6px", objectFit : "cover"}}
                                onError={(e) => { e.currentTarget.style.display = "none"; }}
                            />
                        )}

                        {
                            account.role == AccountRole.MAIN && (
                                <span style={{marginTop : "0"}} className="font-bold">PLAY</span>
                            )
                        }

                        {
                            account.role == AccountRole.BONUS && (
                                <span style={{marginTop : "0"}} className="font-bold">BONUS</span>
                            )
                        }

                        {
                            account.role == undefined && (
                                <span style={{marginTop : "0"}} className="font-bold">{account.currencyCode}</span>
                            )
                        }
                    </div>
                    <div className="col-9 text-right">
                        <span style={{marginTop : "0"}} className="font-bold">{account.amount && account.amount.toLocaleString("en",{maximumFractionDigits:8, minimumFractionDigits:2})}</span>
                    </div>
                </div>
            );

            return (
                <div key={account.accountId || index} className="col-6">
                    {account.accountId != null ? (
                        <NavLink to={"/account/"+account.accountId} className={"account-balance-button " + (account.role == AccountRole.MAIN ? "bg-success" : account.role == AccountRole.BONUS ? "bg-warning" : "")}
                            style={account.role === undefined ? {background:"#434c56"} : {}}>
                            {content}
                        </NavLink>
                    ) : (
                        <NavLink to={"/multibalance-account/"+this.props.userId+"/"+account.currencyCode+"/"+this.props.username} className={"account-balance-button"}
                            style={account.role === undefined ? {background:"#434c56"} : {}}>
                            {content}
                        </NavLink>
                    )}
                </div>

            )
        })
    }

    render() {
        var vaultBalanceUsdt = this.getVaultBalanceUsdt();
        return (
            <div className={"card-box"}>
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col-auto">
                        <h4>Account Balances</h4>
                    </div>
                    <div className="col-auto text-right">
                        <div className="text-muted">Vault Balance</div>
                        <div className="font-bold">{vaultBalanceUsdt.toLocaleString("en",{maximumFractionDigits:2, minimumFractionDigits:2})} USDT</div>
                    </div>
                </div>
                <div className="hr-line-dashed"></div>
                <div className="row">
                    {this.getAccounts(this.props.balances || [])}
                </div>
            </div>
        );
    }

    private getCurrencyIconUrl(currencyCode?: string, role?: string): string | undefined {
        
        if(!currencyCode) {
            return undefined;
        }

        const iconsBaseUrl = getContainer().getSettings().currencyIconsBaseUrl;
        
        if(!iconsBaseUrl) {
            return undefined;
        }

        return iconsBaseUrl.replace(/\/+$/, "") + "/" + currencyCode.toUpperCase() + ".png";
    }

    private getVaultBalanceUsdt(): number {
        if(!this.props.balances) {
            return 0;
        }
        return this.props.balances.reduce((total, account) => {
            if(!account.amount) {
                return total;
            }
            if(account.currencyCode === "USDT") {
                return total + account.amount;
            }
            if(account.exchangeRateUsdt) {
                return total + account.amount * account.exchangeRateUsdt;
            }
            return total;
        }, 0);
    }
}
